import './Dashboard.scss'
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import {Button, Container, ProgressBar} from "react-bootstrap";
import {useContext} from "react";
import AppContext from "../AppContext";
import {FaFacebook, FaInstagram, FaTiktok} from "react-icons/fa6";
import {Link, useNavigate} from "react-router-dom";
import {BsArrowRight} from "react-icons/bs";
import Leaderboard from "../components/Leaderboard";
import DailyItem from "../components/DailyItem";
import CongratulationsWidget from "../components/CongratulationsWidget";
import {useTranslation} from "react-i18next";
import {Trans} from "react-i18next/icu.macro";

export default function Dashboard() {
    const app = useContext(AppContext)
    const { t, i18n } = useTranslation();
    const navigate = useNavigate()
    let progCurrent = app.ui.progress.category.topics_completed + 1
    let progTotal = app.ui.progress.category.topics_total
    if(app.ui.progress.category.has_questions)
        progTotal++

    const subs = app.user.subscriptions;
    const dailies = app.user.dailies;
    let completedDailies = 0;
    Object.keys(dailies).map((k, idx) => {
        let item = dailies[k];
        if(item.completed >= item.required)
            completedDailies++;
    });

    return <div id="page-dashboard" className={"page " + (app.ui.isDrawerOpen ? 'menu-shown' : '')}>
        <Sidebar />
        <div className="page-inner">
            <Header />
            <Container>
                <div className="dashboard-widgets">
                    {app.ui.progress.category.ID > 0 ?
                    <div className="dashboard-widget widget-videocursus">
                        <h3 className="widget-title">{t('videoCourse')}</h3>
                        <div className="widget-body">
                            <div className="widget-image">
                                <img src={app.ui.progress.category.image} alt="" />
                            </div>
                            <div className="widget-text">
                                <div className="videocursus-info" style={{ gap: 20}}>
                                    <div>
                                        <div className="mb-2"><strong>{t('chapter')}:</strong> <span dangerouslySetInnerHTML={{__html: app.ui.progress.category.name}} /></div>
                                        <div className="mb-3"><strong>{t('lesson')}:</strong> <span dangerouslySetInnerHTML={{__html: app.ui.progress.topic.name}} /></div>
                                    </div>
                                    <Button variant="info" onClick={() => navigate('/courses')}>{t('button.continue')}</Button>
                                </div>
                                <div style={{marginTop: 'auto'}}>
                                    <div className="mb-1"><Trans i18nKey="chapterProgress" values={{
                                        completed: progCurrent,
                                        count: progTotal
                                    }} /></div>
                                    <ProgressBar now={Math.round(progCurrent / progTotal * 100)} variant="info" animated />
                                </div>
                            </div>
                        </div>
                    </div> :
                    <CongratulationsWidget />
                    }
                </div>
            </Container>

            <Container>
                <div className="dashboard-widgets three-columns">
                    <div className="dashboard-widget widget-subscriptions">
                        <h3 className="widget-title">{t('dashboard.orders.title')}</h3>
                        <div className="widget-body">
                            <div>
                                <div className="mb-3 text-muted">
                                    <small>
                                        {t('dashboard.orders.subtitle')}
                                    </small>
                                </div>
                                <ul className="subscriptions-list">
                                    <li>
                                        <div className="sub-title mb-2">
                                            <strong>{t('courses.bth')}</strong>
                                            <span className="sub-time-left">{subs?.bth?.promo_active ? <small style={{fontSize: '70%'}}>{t('dashboard.orders.promoDays')}</small> : t('dayWithCount', { count: subs.bth.active })}</span>
                                        </div>
                                        {!subs?.bth?.promo_active ?
                                        <div className="sub-buttons">
                                            {subs.bth.pending > 0 ?
                                                <Link to="/account#orders"
                                                      className="text-info">{t('dashboard.orders.pendingDays', { count: subs.bth.pending })} <BsArrowRight/></Link>
                                                :
                                                <Link to="/pricing/1"
                                                      className="text-success">{t('button.extend')} <BsArrowRight/></Link>
                                            }
                                        </div> : null}
                                    </li>
                                    {app.user?.multilingual != 1 &&
                                        <>
                                    <li>
                                        <div className="sub-title mb-2">
                                            <strong>{t('courses.ath')}</strong>
                                            <span className="sub-time-left">{subs?.ath?.promo_active ? <small style={{fontSize: '70%'}}>{t('dashboard.orders.promoDays')}</small> : t('dayWithCount', { count: subs.ath.active })}</span>
                                        </div>

                                        {!subs?.ath?.promo_active ?
                                        <div className="sub-buttons">
                                            {subs.ath.pending > 0 ?
                                                <Link to="/account#orders"
                                                      className="text-info">{t('dashboard.orders.pendingDays', { count: subs.ath.pending })} <BsArrowRight/></Link>
                                                :
                                                <Link to="/pricing/2"
                                                      className="text-success">{t('button.extend')} <BsArrowRight/></Link>
                                            }
                                        </div> : null}
                                    </li>
                                    <li>
                                        <div className="sub-title mb-2">
                                            <strong>{t('courses.amth')}</strong>
                                            <span className="sub-time-left">{subs?.amth?.promo_active ? <small style={{fontSize: '70%'}}>{t('dashboard.orders.promoDays')}</small> : t('dayWithCount', { count: subs.amth.active })}</span>
                                        </div>
                                        {!subs?.amth?.promo_active ?
                                        <div className="sub-buttons">
                                            {subs.amth.pending > 0 ?
                                                <Link to="/account#orders"
                                                      className="text-info">{t('dashboard.orders.pendingDays', { count: subs.amth.pending })} <BsArrowRight/></Link>
                                                :
                                                <Link to="/pricing/3"
                                                      className="text-success">{t('button.extend')} <BsArrowRight/></Link>
                                            }
                                        </div> : null}
                                    </li></>}
                                </ul>
                            </div>
                        </div>
                    </div>
                    <Leaderboard />
                    <div className="dashboard-widget widget-quests">
                        <h3 className="widget-title">{t('dailies.title')} {completedDailies}/{Object.keys(dailies).length}</h3>
                        <div className="widget-body">
                            <div>
                                <div className="mb-3 text-muted">
                                    <small>
                                        {t('dailies.subtitle')}
                                    </small>
                                </div>
                                <ul className="daily-quests">
                                    <DailyItem item={dailies.topic_completed} text={t('dailies.quests.topicFinished')} link="/courses" />
                                    <DailyItem item={dailies.topic_perfect} text={t('dailies.quests.topicPerfect')} link="/courses" />
                                    <DailyItem item={dailies.simulation_completed} link="/simulation"
                                               text={<Trans i18nKey="dailies.quests.simulation" />} />
                                </ul>
                            </div>
                        </div>
                        <h3 className="widget-title" style={{ marginTop: 80}}>{t('dailies.promo.title')}</h3>
                        <div className="widget-body">
                            <div>
                                <div className="mb-3 text-muted">
                                    <small>
                                        {t('dailies.promo.subtitle')}
                                    </small>
                                </div>
                                <ul className="social-media-links">
                                    <li>
                                        <a href="https://tturl.nl/fb" target="_blank">
                                            <FaFacebook />
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://tturl.nl/tiktok" target="_blank">
                                            <FaTiktok />
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://tturl.nl/ig" target="_blank">
                                            <FaInstagram />
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </Container>
        </div>
    </div>
}